export default __webpack_public_path__ + "static/media/presentacion_retos_efectos_positivos.b24d203d.pdf";